import { authStrategy } from "../../auth";

export async function dashboardFetch(
  url: string,
  options: RequestInit = {}
): Promise<Response> {
  const fetchOptions: RequestInit = {
    credentials: "include",
    ...options,
    headers: {
      ...options.headers,
      Authorization: "Bearer " + authStrategy.getToken()?.token,
    },
  };

  return fetch(url, fetchOptions);
}
